import axios from "axios";
import { credentials } from "@/lib/authStore";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// All credential state lives in the provider-neutral store (authStore). We read it
// LIVE on each request so cross-tab logout / tenant switch is never stale, and a
// native client can swap the store impl (SecureStore) with no call-site changes.
export function setEntity(id) { credentials.setEntity(id || null); }
export function getEntity() { return credentials.getEntity(); }
export function setToken(t) { credentials.setToken(t || null); }
export function getToken() { return credentials.getToken(); }
export function setTenant(id) { credentials.setTenant(id || null); }
export function getTenant() { return credentials.getTenant(); }

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const token = credentials.getToken();
  const tenantId = credentials.getTenant();
  const entityId = credentials.getEntity();
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  if (tenantId && cfg.headers["X-Tenant-Id"] === undefined) cfg.headers["X-Tenant-Id"] = tenantId;
  if (entityId && cfg.headers["X-Entity-Id"] === undefined && !cfg.url?.startsWith("/me/") && !cfg.url?.startsWith("/auth/") && !cfg.url?.startsWith("/support/")) cfg.headers["X-Entity-Id"] = entityId;
  return cfg;
});

export function apiError(e, fallback = "Something went wrong") {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d?.msg || e?.message || fallback;
}
